import { Link } from "react-router-dom";

const ENTRIES = [
  {
    to: "/category/movie",
    icon: "ri-film-line",
    title: "电影",
    desc: "动作、科幻、喜剧、悬疑，类型齐全",
    count: "1200+ 部",
    tone: "primary",
  },
  {
    to: "/category/tv",
    icon: "ri-tv-2-line",
    title: "电视剧",
    desc: "国产剧、美剧、日韩剧，追剧不停",
    count: "860+ 部",
    tone: "accent",
  },
  {
    to: "/news",
    icon: "ri-newspaper-line",
    title: "影视资讯",
    desc: "新片定档、行业观察、幕后花絮",
    count: "每日更新",
    tone: "secondary",
  },
];

export default function CategoryShortcuts() {
  return (
    <section className="w-full px-4 md:px-8 xl:px-16 -mt-12 md:-mt-16 relative z-20">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
        {ENTRIES.map((entry) => {
          const iconBg =
            entry.tone === "primary"
              ? "bg-primary-500 text-background-50"
              : entry.tone === "accent"
              ? "bg-accent-500 text-background-50"
              : "bg-secondary-700 text-background-50";
          return (
            <Link
              key={entry.to}
              to={entry.to}
              className="group flex items-center gap-4 rounded-lg bg-background-50 p-5 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
            >
              <span className={`w-12 h-12 rounded-lg flex items-center justify-center shrink-0 ${iconBg}`}>
                <i className={`${entry.icon} text-2xl`}></i>
              </span>
              <div className="min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="font-heading text-lg font-semibold text-foreground-950">{entry.title}</h3>
                  <span className="text-xs text-foreground-400">{entry.count}</span>
                </div>
                <p className="mt-1 text-xs md:text-sm text-foreground-500 line-clamp-1">{entry.desc}</p>
              </div>
              <i className="ri-arrow-right-line ml-auto text-foreground-300 group-hover:text-primary-600 group-hover:translate-x-0.5 transition-all"></i>
            </Link>
          );
        })}
      </div>
    </section>
  );
}